import Vue from 'vue'
import {
  Tag,
  Input,
  Button
} from 'element-ui'
import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import '../assets/scss/element-variables.scss'

// 设置语言
locale.use(lang)

Vue.use(Tag)
Vue.use(Input)
Vue.use(Button)